// extracted by mini-css-extract-plugin
export var notificationHost = "_c1-0";